import { render } from "./DepEdPersonnels.vue?vue&type=template&id=5e4f26ee"
import script from "./DepEdPersonnels.vue?vue&type=script&lang=js"
export * from "./DepEdPersonnels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__